import { useState } from "react"

import OfferLetterSheet from "../OfferLetterSheet"
import Dialog from "./Dialog"

const OfferLetterAvailableOnboarding = () => {
  const [openDialog, setOpenDialog] = useState(true)
  const [openSheet, setOpenSheet] = useState(false)

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }
  const handleOpenSheet = () => {
    handleCloseDialog()
    setOpenSheet(true)
  }
  return (
    <>
      <Dialog
        open={openDialog}
        handleClose={handleCloseDialog}
        handleOpenSheet={handleOpenSheet}
      />
      <OfferLetterSheet
        open={openSheet}
        handleClose={() => {
          setOpenSheet(false)
        }}
      />
    </>
  )
}

export default OfferLetterAvailableOnboarding
